import api from './api';

const diamantService = {
  // Get available packages
  getPackages: () => api.get('/diamant/packages'),
  
  // Initiate purchase
  initiatePurchase: (packageId, paymentMethodId) => 
    api.post('/diamant/purchase', { package_id: packageId, payment_method_id: paymentMethodId }),
  
  // Confirm purchase
  confirmPurchase: (paymentIntentId) => 
    api.post('/diamant/confirm', { payment_intent_id: paymentIntentId }),
  
  // Get purchase history
  getPurchaseHistory: () => api.get('/diamant/purchases'),
  
  // Get earning history
  getEarningHistory: (limit = 50) => api.get('/diamant/earnings', { params: { limit } }),
  
  // Get earnings summary
  getEarningsSummary: () => api.get('/diamant/earnings/summary'),
  
  // Claim daily reward
  claimDailyReward: () => api.post('/diamant/daily-reward'),
  
  // Get daily status
  getDailyStatus: () => api.get('/diamant/daily-status'),
  
  // Get referral info
  getReferralInfo: () => api.get('/diamant/referral'),
};

export default diamantService;
